<template>
  <div class="home">
    <KeepAlive>
      <FixedHero />
    </KeepAlive>
    <!--<Carousel :banners="banners" />-->
    <Sobre />
    <div class="container">
      <NavJobs />
    </div>
    <Expertises />
    <Footer />
    <back-to-top text="Top"></back-to-top>
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from "@/components/Carousel.vue";
import NavJobs from "@/components/nav-jobs.vue";
import Sobre from "@/components/Sobre.vue";
import BackToTop from "vue-backtotop";
import Expertises from "@/components/Expertises.vue";
import Footer from "@/components/Footer.vue";
import FixedHero from "@/components/FixedHero.vue";

export default {
  data() {
    return {
      banners: ""
    };
  },
  name: "home",
  components: {
    FixedHero,
    Carousel,
    Sobre,
    NavJobs,
    BackToTop,
    Expertises,
    Footer
  }
};
</script>

<style lang="scss" scoped>
.home {
  display: block;
  height: 100vh;
}
</style>
